export var ArtworkUrlType;
(function (ArtworkUrlType) {
    ArtworkUrlType["DocumentReferenceUrl"] = "documentReferenceUrl";
    ArtworkUrlType["ManufacturingReadyDataUrl"] = "manufacturingReadyDataUrl";
})(ArtworkUrlType || (ArtworkUrlType = {}));
//# sourceMappingURL=types.js.map